import React, { useEffect, useState } from 'react'
import { Field } from 'formik'
import { useTranslation } from 'react-i18next'

interface Option {
  value: number | string
  label: string
}

interface SelectOptionsProps {
  options: Option[]
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void
  label?: string
  id: string
  value: number | string
  className?: string
  disabled?: boolean
  justifyCenter?: string
  classNameLabel?: string
  classNameInput?: string
  classNameSelect?: string
  isDefaultValue?: boolean
  error?: string
  optionSelect: boolean
  optionSelectText?: string
}

interface FieldProps {
  form: {
    setFieldValue: (field: string, value: number | string) => void
  }
  field: {
    name: string
    value: number | string
  }
}

const SelectOptions = ({
  options,
  value,
  className = '',
  classNameLabel = '',
  classNameInput = '',
  label,
  justifyCenter = 'align-items-start',
  classNameSelect,
  error,
  isDefaultValue = false,
  form,
  field,
  disabled = false,
  optionSelect = false,
  optionSelectText,
  ...inputProps
}: SelectOptionsProps & FieldProps) => {
  const { t } = useTranslation()
  const [defaultValue, setDefaultValue] = useState(false)

  useEffect(() => {
    if (!value && !defaultValue && optionSelect) {
      form.setFieldValue(inputProps.id, 0)
      setDefaultValue(true)
    } else form.setFieldValue(inputProps.id, options[0].value)
  }, [])

  return (
    <div className={`input-container ${justifyCenter}`}>
      {label !== undefined && (
        <div className={`${classNameLabel} fw-bolder`}>
          <span>{`${label}`}</span>
        </div>
      )}
      <div className={`${classNameInput} pt-2`}>
        <select
          disabled={disabled}
          className={`${classNameSelect} ${className}`}
          value={value}
          {...inputProps}
        >
          {optionSelect && (
            <option
              className='options-box'
              value={optionSelectText}
              key={`all-select`}
            >
              {optionSelectText}
            </option>
          )}

          {options &&
            options.map((option, index) => (
              <option
                className='options-box'
                value={option.value}
                key={`${value}-${option.value}-${index}`}
                disabled={index === 0 && isDefaultValue}
                hidden={index === 0 && isDefaultValue}
              >
                {`${option.label}`}
              </option>
            ))}
        </select>
        {error && (
          <div className='text col-12 pl-0'>
            <p className='color-red small m-0'>{`${error}`}</p>
          </div>
        )}
      </div>
    </div>
  )
}

const Select = ({ ...props }: SelectOptionsProps) => {
  return (
    <Field name={props.id}>
      {({ field, form }: FieldProps) => {
        return <SelectOptions {...props} form={form} field={field} />
      }}
    </Field>
  )
}
export default Select
